// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
    production: false,
    apiVersion: 'api/v1/',
    apiUrlBase: 'https://api.devparqueosrrhh.claro.com.gt/',
    loginOfficeUrl: 'https://api.devparqueosrrhh.claro.com.gt/api/v1/auth/employee/saml/login',

    samlAllowedOrigins: [

        'https://api.devparqueosrrhh.claro.com.gt',
        'https://admin.devparqueosrrhh.claro.com.gt',
        'https://devparqueosrrhh.claro.com.gt',

        //'http://localhost:4200',
        //'https://api.parqueosrrhh.claro.com.gt',
        //'https://admin.parqueosrrhh.claro.com.gt',
        //'https://parqueosrrhh.claro.com.gt',

        //'https://migparqueosrrhh.claro.com.gt',
        //'https://admin.migparqueosrrhh.claro.com.gt',
        //'https://api.migparqueosrrhh.claro.com.gt',

       // 'https://devmigparqueosrrhh.claro.com.gt',
        //'https://admin.devmigparqueosrrhh.claro.com.gt',
        //'https://api.devmigparqueosrrhh.claro.com.gt',
    ],

};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.

